import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router' // 这里引入了路由对象
import * as THREE from 'three'
import BIRDS from 'vanta/src/vanta.birds'
import'./assets/font/Beadly.css'

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router, // 在Vue实例中使用路由对象
}).$mount('#app')
